import React, { Dispatch, forwardRef } from 'react';

import { StringIndexed } from 'types/table';
import { Colors } from 'ui/constants/colors';
import { InfoTableRows } from './info-table-rows';
import { InfoTableHeader } from './info-table-header';
import { IInfoTableColumn, IInfoTableColumnSorting } from 'types/info-table';

import styles from './styles.module.css';

interface IInfoTableProps<T> {
  id?: string;
  data: StringIndexed<T>[] | null;
  columns: IInfoTableColumn<T>[];
  columnsSorting?: IInfoTableColumnSorting[];
  sortColumnData?: Dispatch<IInfoTableColumnSorting>;
  isLoading?: boolean;
  selectedIds?: number[];
  onRowClick?: Dispatch<StringIndexed<T>>;
}

export const InfoTable = <T,>(props: IInfoTableProps<T>) => {
  const { columns, columnsSorting, sortColumnData, ...rest } = props;

  return (
    <div id={props.id} className={styles.table}>
      <InfoTableHeader columns={columns} columnsSorting={columnsSorting} sortColumnData={sortColumnData} />
      <InfoTableRows columns={columns} {...rest} />
    </div>
  );
};
